module.exports = __webpack_public_path__ + "files/d72c797d16b1383ce796e5237c33cd45.svg";